<template>
  <v-autocomplete
    v-model="searchAuto"
    :items="item"
    filled
    rounded
    :search-input.sync="search"
    hide-details
    hide-selected
    hide-no-data
    item-text="customer_name"
    item-value="customer_id"
    placeholder="ค้นหา"
    append-icon
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-text="item.customer_name"></v-list-item-title>
      </v-list-item-content>
      <v-list-item-action>
        <div
          v-if="item.visit_id == 0"
          class="boxs btnplus"
          @click="toAdd(item.customer_id)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-plus-lg"
            viewBox="0 0 16 16"
            style="color: #ffffff"
          >
            <path
              fill-rule="evenodd"
              d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
            />
          </svg>
        </div>

        <div
          v-else-if="item.plan_by == '2' && item.visit_id != 0"
          class="boxs btnmin"
          @click="toRemove(item.visit_id)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-dash-lg"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8Z"
            />
          </svg>
        </div>
      </v-list-item-action>
    </template>

    <template v-slot:prepend-inner>
      <div style="position: absolute; right: 20px; top: 8px">
        <i class="icon-Search"></i>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: ['item', 'date'],

  data() {
    return {
      searchAuto: '',
      search: '',
    }
  },

  methods: {
    toAdd(customerId) {
      const data = {
        method: 'POST',
        headers: this.setheaders,
        body: JSON.stringify({
          customer_id: customerId,
          date: this.date,
        }),
      }

      fetch(`${this.$baseAPI}/visit/set_plan`, data)
        .then((response) => {
          return response.json()
        })
        .then((res) => {
          this.searchAuto = ''
          this.search = ''
          this.$emit('action')
        })
        .catch((error) => {
          console.log(error)
        })
    },

    toRemove(visitId) {
      const data = {
        method: 'POST',
        headers: this.setheaders,
        body: JSON.stringify({
          visit_id: visitId,
        }),
      }

      fetch(`${this.$baseAPI}/visit/inactivePlan`, data)
        .then((response) => {
          return response.json()
        })
        .then((res) => {
          this.searchAuto = ''
          this.search = ''
          this.$emit('action')
        })
        .catch((error) => {
          console.log(error)
        })
    },
  },
}
</script>

<style scoped lang="scss">
.v-list-item {
  border-bottom: 1px solid #cdd8e6 !important;
  margin: 5px 15px !important;
}
.v-input__control {
  border-radius: 10px !important;
}
// .v-select.v-text-field input {
//   padding: 0px 20px !important;
// }
.v-autocomplete__content.v-menu__content {
  border-radius: 8px !important;
}

.profile-user {
  border-radius: 50%;
  height: 50px;
  width: 50px;
  margin-right: 14px;
}

.panel--customer {
  display: flex !important;
  justify-content: space-between !important;
}

.boxs {
  width: 30px;
  display: flex;
  padding: 5px;
  justify-content: center;
  margin-left: 10px;
  align-items: center;
  border-radius: 5px;

  &.btnplus {
    background-color: #b82825;
  }

  &.btnmin {
    background-color: rgb(212, 212, 212);
  }
}
</style>
